import { Progress, Track } from './style';

const ActivityBar = ({ ref }: { ref: React.Ref<HTMLDivElement> }) => (
  <Track>
    <Progress ref={ref} />
  </Track>
);

export default ActivityBar;
